import React from "react";
import { CONSTANT } from "../../../../../constant/Constant";
import { GetDateDetails } from "../../../../../utils/GetDateDetails";

export default function TopSession({ data }) {
  const date = GetDateDetails(data.datetime);
  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 ">
      <div className="">
        <div className="grid grid-cols-2 pt-20">
          <div className="pr-2">
            <p className="text-white text-right font-bold text-xl">
              {date.day.toUpperCase()}
            </p>

            <p className="text-white text-right font-bold text-xl leading-tight">
              <span>
                {date.dayStr}
                <sup className="text-sm align-super">{date.suffix}</sup>{" "}
                {date.month.toUpperCase()}
              </span>
              <br />
              <span className="text-lg font-bold">{date.year}</span>
            </p>
            <p className="text-white text-right  font-bold text-base">
              {date.time}
            </p>
          </div>
          <div className="flex flex-row items-end border-l-2 border-white pl-2">
            <p className="text-white font-bold text-7xl pr-1">
              {date.note.count}
            </p>
            <div>
              <p className="text-white font-bold text-xl">
                {date.note.firstWord}
              </p>
              <p className="text-white font-bold text-xl">
                {date.note.restText}
              </p>
            </div>
          </div>
        </div>

        <div className="text-center py-10 relative flex flex-col justify-center items-center">
          <p className="text-white font-bold text-8xl  font-tangerine">
            {data.bridesName}
          </p>
          <p className="text-white font-bold text-[200px]  opacity-25 absolute text-end w-full pr-10 font-tangerine">
            &amp;
          </p>
          <p className="text-white font-bold text-8xl  font-tangerine">
            {data.groomsName}
          </p>
        </div>
        <div className="pr-10 pb-20 pt-10">
          <p className="text-black font-semibold text-xl text-end ">
            {data.description}
          </p>
        </div>
      </div>

      <div className="">
        <img
          className="w-full md:w-[80%] h-full object-cover"
          src={`${CONSTANT.UI_URL}thumbnail/${data.thumbnail}`}
          alt="thumbnail"
        />
      </div>
    </div>
  );
}
